import React from 'react';
import { firstError } from '@/utils/errors';
import { states } from '@/constants/lifecycle';
import BackButton from '@/components/buttons/BackButton';
import CloseButton from '@/components/buttons/CloseButton';
import ForwardButton from '@/components/buttons/ForwardButton';
import TabActions from '@/components/tabs/TabActions';
import { destinationInfoErrors, supportsAttachmentTransfers } from '../helper';
import Selectors from '../hooks/selectors';
import Events from '../hooks/events';
import AttachmentEvents from '../attachments/hooks/events';

const DestinationInfoActions = ({
  category,
  code,
  compact,
  goBack,
  goForward,
}) => {
  const state = Selectors.useDestinationInfoActions({ category, code });
  const cancelRequest = Events.useDestroyRequests();
  const updateProperties = Events.useUpdateRequestProperties(category, { code });
  const updateTransferType = Events.useUpdateRequestTransferType(category, { code });
  const fetchAttachments = AttachmentEvents.useFetchRequestAttachments(category, { code });

  const onNext = () => {
    updateTransferType(state);
    const saveErrors = state.readErrors.concat(destinationInfoErrors(state));

    if (saveErrors.length > 0) {
      updateProperties({ properties: { saveErrors } });
    } else if (state.attachments.readStatus === states.NONE
        && supportsAttachmentTransfers(state)) {
      fetchAttachments(state);
    } else { goForward(); }
  };

  const disabled = (!state.workspace && !state.requestNewWorkspace)
      || firstError(state.readErrors)
      || state.attachments.readStatus === states.PENDING
      || state.settingsReadStatus !== states.SUCCESS;

  return (
    <TabActions className="aridhia-request-access-wizard-actions">
      <CloseButton
        disabled={state.saveStatus === states.PENDING}
        onClick={() => cancelRequest({
          items: [{ code, isNew: true, steps: { sourceUrl: state.sourceUrl } }],
          isArchival: false,
          silent: true,
        })}
      />
      {state.selectSource && (
        <BackButton onClick={goBack} disabled={state.saveStatus === states.PENDING} iconOnly={compact} />
      )}
      <ForwardButton disabled={disabled} iconOnly={compact} onClick={onNext} />
    </TabActions>
  );
};

export default DestinationInfoActions;
